export function BackendVersionBadge({
  backendVersion,
  adminUrl,
  compact,
}: {
  backendVersion: string;
  adminUrl: string;
  compact: boolean;
}) {
  if (compact) return null;
  return (
    <div className="px-1.5 text-center text-tiny text-grey-500">
      <a
        href={adminUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="transition-colors hover:text-green-400"
        style={{ textDecoration: "none", color: "inherit" }}
      >
        B-{backendVersion}
      </a>
    </div>
  );
}
